import { AutogenModelEdiTemplate, AutogenRowEdiTemplate } from "./autogen/AutogenModelEdiTemplate";

export class ModelEdiTemplate extends AutogenModelEdiTemplate<RowEdiTemplate> {
	constructor() {
		super(RowEdiTemplate);
	}
}

export class RowEdiTemplate extends AutogenRowEdiTemplate {
}